import React, { Component } from 'react';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';
import styles from './RadioMenu.scss';

import Menu from '../Menu/Menu';
import Checkbox from '../Checkbox/Checkbox';
import Button from '../Button/Button';
import { gaEvent, trackGA } from '../../../services/ga';

class RadioMenu extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: 0
    };
  }

  onMouseEnter(key, e) {
    this.setState({ activeTabIndex: key });
  }

  handleSelect(keys, add) {
    const { handle, checked, menus, profile, mode, objectType } = this.props;
    const values = [...checked];
    keys.forEach((key) => {
      const include = values.includes(key);
      if (include !== add) {
        if (add) {
          values.push(key);
        } else {
          values.splice(values.indexOf(key), 1);
        }
      }

      if (keys.length === 1) {
        for (let i = 0; i < menus.length; i++) {
          const { checkboxes } = menus[i];
          if (checkboxes[key]) {
            trackGA(gaEvent.filterMicrodistrictButtonsClick({
              eventContent: [checkboxes[key], ` | ${add ? 'on' : 'off'}`],
              eventContext: mode,
              productType: objectType,
              user_id: profile.id
            }));
          }
        }
      }
    });
    handle(values);
  }

  handleGroupSelect(key, bool) {
    const { menus, mode, objectType, profile } = this.props;
    const { checkboxes } = menus[key];
    const keys = Object.keys(checkboxes);
    this.handleSelect(keys, bool);

    const selectedDistrictName = menus[key].tabText;
    trackGA(gaEvent.filterDistrictButtonsClick({
      eventContent: [selectedDistrictName, ` | ${bool ? 'on' : 'off'}`],
      eventContext: mode,
      productType: objectType,
      user_id: profile.id
    }));
  }

  isGroupChecked(key) {
    const { menus, checked } = this.props;
    const { checkboxes } = menus[key];
    const keys = Object.keys(checkboxes);
    return keys.every((key) => checked.includes(key));
  }

  isGroupPartialChecked(key) {
    const { menus, checked } = this.props;
    const { checkboxes } = menus[key];
    const keys = Object.keys(checkboxes);
    return keys.some((key) => checked.includes(key));
  }

  renderMenu() {
    const { activeTabIndex } = this.state;
    const { menus, checked, className, t } = this.props;
    const { checkboxes } = menus[activeTabIndex];
    const keys = Object.keys(checkboxes);
    const firstColumnCount = Math.floor((keys.length % 2 != 0) ? (keys.length / 2 + 1) : (keys.length / 2));
    const firstColumn = keys.slice(0, firstColumnCount);
    const secondColumn = keys.slice(firstColumnCount);

    return (
      <div className={cn(styles.Menu, className)}>

        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {firstColumn.map((key) => (
              <Checkbox
                key={key}
                className={styles.Checkbox}
                text={checkboxes[key]}
                checked={checked.includes(key)}
                handle={this.handleSelect.bind(this, [key])}
              />
            ))}
          </div>
          <div className={styles.SecondColumn}>
            {secondColumn.map((key) => (
              <Checkbox
                key={key}
                className={styles.Checkbox}
                text={checkboxes[key]}
                checked={checked.includes(key)}
                handle={this.handleSelect.bind(this, [key])}
              />
            ))}
          </div>
        </div>
        <div className={styles.Buttons}>
          <Button className={styles.Button} onClick={this.handleSelect.bind(this, keys, true)}>
            {t('components.common.radioMenu.selectAll')}
          </Button>

        </div>
      </div>
    );
  }

  renderTabs() {
    const { activeTabIndex } = this.state;
    const { menus } = this.props;

    return menus.map((menu, i) => {
      const { tabText } = menu;
      return (
        <div key={i} className={cn(styles.Tab, { [styles.TabActive]: activeTabIndex === i })} onMouseEnter={this.onMouseEnter.bind(this, i)}>
          <Checkbox
            className={styles.Checkbox}
            checked={this.isGroupChecked(i)}
            partialChecked={this.isGroupPartialChecked(i)}
            handle={this.handleGroupSelect.bind(this, i)}
            text={tabText}
          />
        </div>
      );
    });
  }

  render() {
    const { menus, checked, t, mode, objectType, profile } = this.props;
    const keys = Array.prototype.concat.apply([], menus.map(menu => Object.keys(menu.checkboxes)));
    return (
      <Menu className={styles.FiltersMenu} >
        <p className={styles.Title}>
          {t('components.common.radioMenu.select')}
          {
            !!checked.length &&
            <Button
              className={cn(styles.Button, styles.ButtonReset)}
              onClick={() => {
                this.handleSelect(keys, false);
                trackGA(gaEvent.filterClearButtonsClick({
                  eventContent: 'raion',
                  eventContext: mode,
                  productType: objectType,
                  user_id: profile.id
                }));
              }}
            >
              {t('components.common.radioMenu.clear')}
            </Button>
          }
        </p>
        <div className={styles.Container}>
          <div className={styles.Tabs}>
            {this.renderTabs()}
          </div>
          {this.renderMenu()}
        </div>
      </Menu>
    );
  }
}

export default withTranslation()(RadioMenu);



// WEBPACK FOOTER //
// ./src/components/common/RadioMenu/RadioMenu.js